import { Flex, IconButton, useDisclosure } from '@chakra-ui/react';
import { Drawer } from '@kintsugi/ui';
import { FiMenu } from 'react-icons/fi';

import { Sidebar } from '.';

export const MobileSubNav = ({ initialDrawerOpen }: { initialDrawerOpen: boolean }) => {
  const { open, onOpen, onClose, onToggle } = useDisclosure({
    defaultOpen: initialDrawerOpen,
  });

  return (
    <Flex
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 24 }}
      height="20"
      alignItems="center"
      borderBottomWidth="1px"
      borderBottomColor="colorPalette.border"
      justifyContent={'space-between'}
    >
      <IconButton minW="initial" variant="outline" onClick={onOpen} aria-label="open menu">
        <FiMenu />
      </IconButton>
      <Drawer.Root open={open} placement="start" onPointerDownOutside={onToggle}>
        {/* Match org-app mobile nav: no dimmed scrim, width hugs the sidebar. */}
        <Drawer.Content backdrop={false} maxW="fit-content">
          <Sidebar onClose={onClose} hideToggleBtn />
        </Drawer.Content>
      </Drawer.Root>
    </Flex>
  );
};
